import { getCsrfValue } from "~/common/utils/ApiHelper";
import type { UnitMode } from "~/domains/userPreferences/types/UnitMode";
import type { SearchDisplayMode } from "~/features/search/models/models";
import { resolveApiUrl } from "~/utils/url/urlResolver";

interface SRPPreferencesApi {
  view: SearchDisplayMode;
  unit: UnitMode;
}

export const apiUpdateUserPreferences = (updates: Partial<SRPPreferencesApi>) => {
  const url = resolveApiUrl("/search/updatePreferences");
  const body = {
    unit: updates.unit,
    searchView: updates.view,
  };

  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    body: JSON.stringify(body),
  });
};
